import React from "react";
import "./NotFoundPage.css";

const NotFoundPage = () => {
  return (
    <div className="notfoundpage">
      <h1>404 - Page Not Found</h1>
      <p>The page you're looking for does not exist.</p>
    </div>
  );
};

export default NotFoundPage;
